// src/app/redux/reducers/sallesReducer.js

import {
    SET_SALLES_LOADING,
    SET_SALLES_ERROR,

    FETCH_SALLES_SUCCESS,
    FETCH_SALLES_FAIL,

    CREATE_SALLE_FAIL,
    UPDATE_SALLE_FAIL,

    DELETE_SALLE_SUCCESS,
    DELETE_SALLE_FAIL,
} from "../actions/sallesActions";

const initialState = {
    loading: false,
    error: null,
    salles: [],
};

export default function sallesReducer(state = initialState, action) {
    switch (action.type) {
        case SET_SALLES_LOADING:
            return { ...state, loading: action.payload };

        case SET_SALLES_ERROR:
            return { ...state, error: action.payload };

        case FETCH_SALLES_SUCCESS:
            return { ...state, salles: action.payload || [], error: null };

        case FETCH_SALLES_FAIL:
        case CREATE_SALLE_FAIL:
        case UPDATE_SALLE_FAIL:
        case DELETE_SALLE_FAIL:
            return { ...state, error: action.payload };

        case DELETE_SALLE_SUCCESS:
            return { ...state, salles: state.salles.filter((s) => s.id !== action.payload), error: null };

        default:
            return state;
    }
}
